import Vue from "vue";
import "./bootstrap";
import "./plugins/axios";
import "./assets/scss/app.scss";

import App from "./App";
import i18n from "./i18n/index";
import store from "./modules/admin/store/index";
import router from "./routes";

import Keycloak from 'keycloak-js';
import config from './config';

const keycloak = new Keycloak({
  url: config.iam.url,
  realm: config.iam.realm,
  clientId: config.iam.clientId,
  onLoad: 'login-required'
});

Vue.prototype.$auth = keycloak

keycloak.init({onLoad: 'login-required'}).then((auth) => {
  if (!auth) {
    return window.location.reload();
  }

  initVueApp()
  setInterval(updateToken, 6000)
})

const updateToken = async () => {
  try {
    let refreshed = await keycloak.updateToken(70)

    if (!refreshed) {
      return console.warn('Token not refreshed, valid for '
        + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
    }

    console.info('Token refreshed' + refreshed);
  } catch (err) {
    console.error('Failed to refresh token');
  }
}

const initVueApp = () => {
  window.app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    mounted() {
      this.$store
        .dispatch('loadUser')
        .then(() => this.$store.dispatch("initAdminPanel"))
        .catch((err) => {
          if (err.response.status == 403) {
            this.$store.dispatch("showUnauthorizedError")
          }
        })
    },
  }).$mount("#app");
}
